import React,{useState} from 'react'
import LoginHeader from '../components/LoginHeader'
import Footer from '../components/Footer';
import images from '../utils/imageImports';
import { Link } from 'react-router-dom';
 import { login } from '../actions/auth';
 import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PasswordVisibilityToggler from '../utils/passwordVisibityToggler';
function Login({login }) {
    const navigate = useNavigate();
    const [passwordInputType, toggleIcon] = PasswordVisibilityToggler();
    const [user, setuser] = useState({
        email:"",
        password:"",
    })
const handleChange =(e)=>{
    
    const { name, value } = e.target;
    // console.log(e);
    setuser({...user, [name] : value})
}
const onSubmit = async ()=>{
    console.log(user);
    try {
       await login(user);
        // console.log(user)
    navigate("/dashboard"); 
        
      } catch (e) {
        console.log(e);
      }
}
// console.log(user);
  return (
    <div>
<LoginHeader />
<section id="main">
<div className="container position-relative">
    <div className="row">
        <div className="col-md-4 mt-3">
            <form className="mt-5">
            <div className="welcard p-4 mt-5">
                <p className="mb-5 mt-2"><img src={images.loginicon} alt="" /></p>
                <h6>Welcome to VYLDFYRE</h6>
                <p>Please sign in or sign up below.</p>
                    <div className="text-start mt-4">
                      <p className="mb-4"><input type="email" name="email" value={user.email} onChange={handleChange} className="form-control text-light" placeholder="Email" required /></p>
                      <p><input type={passwordInputType} className="form-control text-light" name="password" value={user.password} onChange={handleChange} placeholder="Password" required />
                      <span
                        className="passwordToggle"
                        style={{ color: "white" }}
                      >
                        {toggleIcon}
                      </span>
                      </p>
                      <Link onClick={onSubmit} className="loginbtn my-4">Login</Link>
                    </div>
            </div>
            {/* <div className="googlecard p-4">
                    <a className="googlebtn my-2"><img src={images.googleicon} className="pe-2" alt="" /> Log in
                      with Google</a>
            </div> */}
            <p className="text-center pt-4 mb-5">Don't have an account? <Link to="/register" className="linkyellow1">Sign up</Link></p>
            </form>
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-7 dispnone">
            <img src={images.innerbg} className="img-fluid w-100" alt="" />
        </div>
     </div>

</div>
</section>
<Footer />
    </div>
  )
}
Login.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
 
  
};
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  auth: state.auth,
});


export default connect(mapStateToProps, { login,  })(
    Login
  );